import { language } from '../languages/parser'

import REFERENTIAL from '../referential/20251006_makerReferential.json'
import { componentsReferences } from '../referential/gassienComponents'

export const device = '€'

// export const formatPrice = (price) => `${parseFloat(price).toFixed(2).replace('.', ',')} €`
export const formatPrice = (price) => price.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })

const getRefAttribute = (attribute, type, metalColor, woodColor) => {
  const typesItems = Object.values(REFERENTIAL).filter((el) => el.type === type)
  const item = type.slice(0, 8) === 'planche_'
    ? typesItems
      .filter(
        (el) => el.metal_color === metalColor && el.wood_color === woodColor,
      )[0][attribute] || null
    : typesItems.filter((el) => el.metal_color === metalColor)[0][attribute] || null
  return item
}

export const getCartArray = (elements, metalColor, woodColor) => {
  const cart = {}
  elements
    .filter((el) => el.type !== 'box')
    .forEach((el) => {
      const { type } = el
      if (cart[type]) {
        cart[type].qty += 1
      } else {
        const sku = getRefAttribute('sku', componentsReferences[type], metalColor, woodColor)
        const priceHt = REFERENTIAL[sku].price_ht || 0
        const priceTtc = REFERENTIAL[sku].price_ttc || 0

        cart[type] = {
          qty: 1,
          type: componentsReferences[type],
          name: getRefAttribute(`name-${language}`, componentsReferences[type], metalColor, woodColor),
          id: getRefAttribute('ID', componentsReferences[type], metalColor, woodColor),
          img: getRefAttribute('img', componentsReferences[type], metalColor, woodColor),
          sku,
          priceHt,
          priceTtc,
        }
      }
    })

  const cartArray = Object.keys(cart).map((el) => (
    {
      key: cart[el].id,
      id: cart[el].id,
      name: cart[el].name,
      qty: cart[el].qty,
      priceHt: cart[el].priceHt,
      priceTtc: cart[el].priceTtc,
      img: cart[el].img,
      sku: cart[el].sku,
      metalColor,
      woodColor,
    }
  ))
    .reduce((acc, cur) => {
      // Function to group elements with the same SKU
      if (acc.filter((el) => el.sku === cur.sku).length > 0) {
        return acc.map((e) => {
          if (e.sku === cur.sku) {
            return { ...e, qty: e.qty + cur.qty }
          }
          return { ...e }
        })
      }
      return [...acc, cur]
    }, [])

  return { cart, cartArray }
}

export const getTotalPrice = (elements, metalColor, woodColor) => {
  const { cartArray } = getCartArray(elements, metalColor, woodColor)
  const totalHt = cartArray.reduce((acc, cur) => acc + (cur.priceHt * cur.qty), 0)
  const totalTtc = cartArray.reduce((acc, cur) => acc + (cur.priceTtc * cur.qty), 0)
  return { totalHt, totalTtc }
}
